import api from "../../../libs/api";

angular
  .module("AccountingBoxApp")
  .controller("ReportingYearClosureCtrl", function(
    $scope,
    $http,
    $state,
    $location,
    JournalEntry,
    $rootScope
  ) {
    var vm = this;
    vm.year = $rootScope.currentYear()

    vm.generateAnnualReport = async function() {
      const response = await api.get("/Rapporting/annual-report", {
        responseType: "blob",
        params: { year: vm.year}
      });
      let fileName = `Jaarrekening ${$rootScope.currentCompany.name} ${vm.year}.xlsx`;
      if($rootScope.currentCompany.businessType !== "B.V.") {
        fileName = `Financiële rapportage ${$rootScope.currentCompany.name} ${vm.year}.xlsx`;
      }
      $rootScope.download(response, fileName);
    }
    vm.closeYear = function() {
      vm.loading = true;
      JournalEntry.yearClosure(
        { year: vm.year },
        function(result) {
          console.log(result);
          console.log("status: ", result.status);
          vm.loading = false;
          $state.go("app.company.edit.journalEntries", {
            id: result.yearClosure.id
          });
        },
        function(error) {
          vm.loading = false;
          window.swal(
            "Mislukt",
            "Jaar afsluiten niet mogelijk. Er zit een verschil in de boekhouding.",
            "error"
          );
        }
      );
    };
  });
